(() => {
  const initialized = new WeakSet();
  const showZone = (root, id) => {
    root.querySelectorAll('[data-cf-hotspot]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.cfHotspot === id)));
    root.querySelectorAll('[data-cf-panel]').forEach(panel => { panel.hidden = panel.dataset.cfPanel !== id; });
  };
  const updatePack = (root, value) => {
    const count = Number(value);
    if (![1, 2, 5].includes(count)) return;
    const product = document.querySelector('crewford-order');
    if (product?.setPack) product.setPack(count);
    const link = root.querySelector('[data-cf-pack-cta]');
    if (!link) return;
    const url = new URL(link.getAttribute('href'), location.href);
    if (url.origin !== location.origin || !url.pathname.endsWith('/products/crewford-work-socks')) return;
    url.searchParams.set('pack', String(count));
    link.href = url.pathname + url.search + url.hash;
  };
  const setup = (scope = document) => {
    scope.querySelectorAll('[data-cf-hotspots], [data-cf-carousel], [data-cf-product], [data-cf-packs]').forEach(root => {
      if (initialized.has(root)) return;
      initialized.add(root);
      const selectedPack = root.querySelector('[data-cf-pack]:checked');
      if (selectedPack) updatePack(root, selectedPack.value);
      root.addEventListener('click', event => {
        const dot = event.target.closest('[data-cf-hotspot]');
        if (dot) showZone(root, dot.dataset.cfHotspot);
        const direction = event.target.closest('[data-cf-next], [data-cf-prev]');
        if (direction) {
          const track = root.querySelector('[data-cf-track]');
          const card = track.querySelector('.cf-ugc-card');
          track.scrollBy({left: (card.getBoundingClientRect().width + 20) * (direction.hasAttribute('data-cf-next') ? 1 : -1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        }
        const thumb = event.target.closest('[data-cf-thumb]');
        if (thumb) {
          const source = thumb.querySelector('img');
          const main = root.querySelector('[data-cf-main-image] img');
          ['src', 'srcset', 'sizes', 'alt'].forEach(name => {
            if (source.hasAttribute(name)) main.setAttribute(name, source.getAttribute(name));
            else main.removeAttribute(name);
          });
          root.querySelectorAll('[data-cf-thumb]').forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
        }
      });
      const track = root.querySelector('[data-cf-track]');
      if (track) track.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          root.querySelector(event.key === 'ArrowRight' ? '[data-cf-next]' : '[data-cf-prev]').click();
        }
      });
      root.addEventListener('change', event => {
        if (event.target.matches('[data-cf-pack]')) {
          updatePack(root, event.target.value);
        }
        if (event.target.matches('[data-cf-variant]')) {
          const option = event.target.selectedOptions[0];
          root.querySelector('[data-cf-add]').disabled = !option || option.dataset.available !== 'true';
        }
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup());
  else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:block:select', event => {
    const root = event.target.closest('[data-cf-hotspots]');
    if (root) showZone(root, event.detail.blockId);
  });
})();
